// Ordered bootstrap pipeline. main.ts calls `bootstrap()` and nothing else.
//
// Order rationale:
//   1. initEnv           — fail fast on missing config; nothing downstream can
//                          trust env vars without this running first.
//   2. createAppInstance — Vue app + plugins (so initSentry has an app to attach to).
//   3. initSentry        — must run before initLogger so the Sentry SDK is ready
//                          before the Sentry transport is registered.
//   4. initLogger        — registers the Sentry breadcrumb/event transport.
//   5. initObservability — no-op until OTel is wired; runs after Sentry so the
//                          two systems can share trace context.
//   6. initWebVitals     — registers Core Web Vitals listeners; safe to run late.
//   7. initChunkReload   — reloads once when a post-deploy stale chunk fails to load.
//   8. app.mount         — last, after every observer and transport is wired.

import { initSentry } from '@core/monitoring/sentry'
import { initWebVitals } from '@core/monitoring/webVitals'
import { initChunkReload } from './initChunkReload'
import { initEnv } from './initEnv'
import { initLogger } from './initLogger'
import { initObservability } from './initObservability'
import { createAppInstance, router } from './initApp'

export const bootstrap = (): void => {
  initEnv()
  const app = createAppInstance()
  initSentry(app, router)
  initLogger()
  initObservability()
  initWebVitals()
  initChunkReload(router)
  app.mount('#app')
}
